const RADIX_POPPER = "[data-radix-popper-content-wrapper]";

function isInsideRadixPopper(t: EventTarget | null | undefined): boolean {
  return t instanceof Element && !!t.closest(RADIX_POPPER);
}

/** Dialog/Sheet: ne nyelje el a portált Popover/Dropdown interakcióit (pl. görgetés, fókusz). */
export function preventDismissWhenPointerOnRadixPopper(e: {
  preventDefault: () => void;
  target?: EventTarget | null;
  relatedTarget?: EventTarget | null;
  detail?: {
    originalEvent?: { target?: EventTarget | null; relatedTarget?: EventTarget | null };
  };
}): void {
  const orig = e.detail?.originalEvent;
  const candidates = [orig?.relatedTarget, orig?.target, e.relatedTarget, e.target];
  for (const t of candidates) {
    if (isInsideRadixPopper(t)) {
      e.preventDefault();
      return;
    }
  }
}
